// import LayoutPage from './Base';
import LayoutPage from '../layouts/base';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPencil, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../constants/ApiConfig';
import { Button, Form, Modal } from 'react-bootstrap';
import SuccessModal from "../components/success-modal";
import { useAuth } from '../../services/AuthProvider';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


function CloneListingPage() {

    const { user, hasPermission } = useAuth();

    const canCreateClone = hasPermission('create-clone');
    const canEditClone = hasPermission('edit-clone');
    const canDeleteClone = hasPermission('delete-clone');

    const itemsPerPage = 10;

    const [diseaseData, setCloneData] = useState([]);
    const handleCloneModal = () => setShowModal(true);
    const [cloneName, setCloneName] = useState('');
    const handleModalClose = () => setShowModal(false);
    const [showModal, setShowModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [editCloneName, setEditCloneName] = useState('');
    const [editCloneId, setEditCloneId] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const handleEditModalClose = () => setShowEditModal(false);
    const [showSuccessDeleteModal, setshowSuccessDeleteModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    useEffect(() => {
        const fetchCloneData = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}clone/index`);
                if (response.ok) {
                    const data = await response.json();
                    setCloneData(data)
                }
            } catch (error) {
                console.error('Error fetching clone data:', error);
            }
        };

        fetchCloneData();
    }, []);

    const handleNameChange = (e) => {
        setCloneName(e.target.value);
    };

    const handleSubmitClone = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_BASE_URL}clone/store`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ cloneName }),
            });

            if (response.status == 200) {
                setShowModal(false);
                setShowSuccessModal(true);
            }

        } catch (error) {
            // Handle fetch errors
            console.error('Error:', error);
        }
    }

    const handleEditCloneModal = (diseaseId) => {
        setEditCloneId(diseaseId);
        setShowEditModal(true);
    };

    // Function to fetch zone data by ID
    const fetchCloneById = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}clone/edit/${id}`);
            if (response.ok) {
                const data = await response.json();
                console.log(data)
                setEditCloneName(data.name);
            }
        } catch (error) {
            console.error('Error fetching clone:', error);
        }
    };

    useEffect(() => {
        if (editCloneId !== null) {
            fetchCloneById(editCloneId);
        }
    }, [editCloneId]);

    const handleEditedNameChange = (event) => {
        setEditCloneName(event.target.value);
    };

    const handleSubmitEditClone = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_BASE_URL}clone/update/${editCloneId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ cloneName: editCloneName }),
            });

            if (response.ok) {
                setShowEditModal(false);
                setShowSuccessModal(true);
            }
        } catch (error) {
            // Handle fetch errors
            console.error('Error updating zone:', error);
        }
    }

    const handleDeleteClone = async (index) => {
        try {
            const response = await fetch(`${API_BASE_URL}clone/destroy/${index}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status == 200) {
                setShowDeleteModal(false);
                setshowSuccessDeleteModal(true);
            }

        } catch (error) {
            // Handle fetch errors
            console.error('Error:', error);
        }
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setDeleteIndex(null);
    };

    const handleConfirmDelete = (id) => {
        setDeleteIndex(id);
        setShowDeleteModal(true);
    };


    const closeSuccessModal = () => {
        setShowSuccessModal(false);
        window.location.reload();
    };

    // Pagination Start
    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = diseaseData.slice(indexOfFirstItem, indexOfLastItem);

    const renderIndex = (index) => {
        return (currentPage - 1) * itemsPerPage + index + 1;
    };

    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        setCurrentPage(currentPage - 1);
    };
    // Pagination end

    return (
        <LayoutPage>
            <div className='children'>
                <div className="d-flex listTopBar top_bar p-3 bold_poppins justify-content-between">
                    <h4 className="mt-3 pg_title">
                     LIST OF CLONES
                    </h4>
                </div>
                {canCreateClone && <div className="addDisease mt-3 d-flex justify-content-center mb-4" onClick={handleCloneModal}>
                    <div className="icon">
                        <FontAwesomeIcon className="icon" icon={faPlus} />
                    </div>
                    <div className="text ml-3">
                        Clone
                    </div>
                </div>}

                <div>
                    {currentItems.map((clone, index) => (
                        <div key={index} className="listBar p-3 my-3">
                            <div className="d-flex justify-content-between mx-4">
                                <div className="regular_poppins">
                                    {renderIndex(index)}. {clone.name}
                                </div>
                                <div className="regular_poppins">
                                    {canEditClone &&
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>} >
                                            <FontAwesomeIcon icon={faPencil} className="icon edit-icon" onClick={() => handleEditCloneModal(clone.id)} />
                                        </OverlayTrigger>
                                    }
                                    {canDeleteClone &&
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>} >
                                            <FontAwesomeIcon icon={faTrash} className="icon delete-icon" onClick={() => handleConfirmDelete(clone.id)} />
                                        </OverlayTrigger>
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className='pagination'>
                        <button onClick={handlePrevPage} disabled={currentPage === 1}>
                            Prev
                        </button>
                        <button onClick={handleNextPage} disabled={indexOfLastItem >= diseaseData.length}>
                            Next
                        </button>
                    </div>
                </div>

            </div>

            {/* Modal Create Clone */}
            <Modal className='modal_responsive' show={showModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Clone</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Your form content */}
                    <Form onSubmit={handleSubmitClone}>
                        <Form.Group controlId="formCloneName" >
                            <Form.Label className="label-left">Clone Name</Form.Label>
                            <Form.Control value={cloneName} onChange={handleNameChange} type="text" placeholder="Enter clone name" required />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="mt-4">
                            Submit
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal Update Zone */}
            <Modal className='modal_responsive' show={showEditModal} onHide={handleEditModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Clone</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmitEditClone}>
                        <Form.Group controlId="formCloneName" >
                            <Form.Label className="label-left">Clone Name</Form.Label>
                            <Form.Control
                                value={editCloneName}
                                onChange={handleEditedNameChange}
                                type="text"
                                placeholder="Enter clone name"
                                required
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="mt-4">
                            Update
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal/Popup for Success Message */}
            <SuccessModal
                className='modal_responsive'
                show={showSuccessModal}
                onHide={closeSuccessModal}
                title="Success"
                modalBody={<p>Data successfully saved!</p>}
                buttonText="Close"
            />

            {/* Delete Modal */}
            <Modal className='modal_responsive' show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this clone?
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseDeleteModal}>
                        Cancel
                    </Button>
                    <Button className="delete-button" onClick={() => handleDeleteClone(deleteIndex)}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal/Popup for Confirmation Delete */}
            <SuccessModal
                className='modal_responsive'
                show={showSuccessDeleteModal}
                onHide={closeSuccessModal}
                title="Data Deleted"
                modalBody={<p>Data was successfully deleted!</p>}
                buttonText="OK"
            />

        </LayoutPage>
    )
}

export default CloneListingPage